"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportedHydrogen = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const SelectCard_1 = require("../../inputs/SelectCard");
const ResourceType_1 = require("../../ResourceType");
const CardName_1 = require("../../CardName");
const Resources_1 = require("../../Resources");
const PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
const CardRenderer_1 = require("../render/CardRenderer");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
class ImportedHydrogen extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.IMPORTED_HYDROGEN,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.SPACE],
            cost: 16,
            tr: { oceans: 1 },
            metadata: {
                cardNumber: '019',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.plants(3).digit;
                    b.or();
                    b.microbes(3).digit.asterix().or();
                    b.animals(2).digit.asterix().br;
                    b.oceans(1);
                }),
                description: 'Gain 3 Plants, or add 3 Microbes or 2 Animals to ANOTHER card. Place an ocean tile.',
            },
        });
    }
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        this.howToAffordReds = undefined;
        return true;
    }
    play(player) {
        const availableMicrobeCards = player.getResourceCards(ResourceType_1.ResourceType.MICROBE);
        const availableAnimalCards = player.getResourceCards(ResourceType_1.ResourceType.ANIMAL);
        const gainPlants = function () {
            player.addResource(Resources_1.Resources.PLANTS, 3, { log: true });
            player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
            return undefined;
        };
        if (availableMicrobeCards.length === 0 && availableAnimalCards.length === 0) {
            return gainPlants();
        }
        const availableActions = [];
        const gainPlantsOption = new SelectOption_1.SelectOption('Gain 3 plants', 'Gain plants', gainPlants);
        availableActions.push(gainPlantsOption);
        if (availableMicrobeCards.length === 1) {
            const targetMicrobeCard = availableMicrobeCards[0];
            availableActions.push(new SelectOption_1.SelectOption('Add 3 microbes to ' + targetMicrobeCard.name, 'Add microbes', () => {
                player.addResourceTo(targetMicrobeCard, { qty: 3, log: true });
                player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
                return undefined;
            }));
        }
        else if (availableMicrobeCards.length > 1) {
            availableActions.push(new SelectCard_1.SelectCard('Add 3 microbes to a card', 'Add microbes', availableMicrobeCards, (foundCards) => {
                player.addResourceTo(foundCards[0], { qty: 3, log: true });
                player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
                return undefined;
            }));
        }
        if (availableAnimalCards.length === 1) {
            const targetAnimalCard = availableAnimalCards[0];
            availableActions.push(new SelectOption_1.SelectOption('Add 2 animals to ' + targetAnimalCard.name, 'Add animals', () => {
                player.addResourceTo(targetAnimalCard, { qty: 2, log: true });
                player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
                return undefined;
            }));
        }
        else if (availableAnimalCards.length > 1) {
            availableActions.push(new SelectCard_1.SelectCard('Add 2 animals to a card', 'Add animals', availableAnimalCards, (foundCards) => {
                player.addResourceTo(foundCards[0], { qty: 2, log: true });
                player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
                return undefined;
            }));
        }
        return new OrOptions_1.OrOptions(...availableActions);
    }
    getActionDetails(_player, card) {
        return new RedsPolicy_1.ActionDetails({ card: card, oceansToPlace: 1 });
    }
}
exports.ImportedHydrogen = ImportedHydrogen;
//# sourceMappingURL=ImportedHydrogen.js.map